module.exports = __webpack_public_path__ + "static/media/video5.46eebb1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video5.mp4
// module id = JTMp
// module chunks = 1